<template>
  <section>
    <aside class="main-sidebar position-fixed bg-white border-right">
    <!-- Brand Logo -->
    <div class="sidebar-logo py-2">
      <router-link to="/">
        <img src="../../public/img/hotel-deliriver.png" alt="AdminLTE Logo" class="brand-image img-circle" style="opacity: .8">
      </router-link>
    </div>

    <!-- Sidebar -->
    <div class="sidebar pb-5">
      


      <!-- Sidebar Menu -->
      <nav class="text-left">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <router-link to="/" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-chart-pie"></i>
              </div>
              <div class="">
                <p>
                  Dashboard
                </p>
              </div>
          </router-link>
          <!-- <li class="nav-item p-0">
            <a href="" class="nav-link">
              Dashboard
            </a>
            <div class="nav nav-treeview">
              
                <a href="./index.html" class="nav-link active">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Dashboard v1</p>
                </a>
              </li>
            </div>
          </li> -->
          <router-link to="/reservation" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-clipboard-list"></i>
              </div>
              <div class="">
                <p>
                  Reservation
                </p>
              </div>
          </router-link>
          <router-link to="/guest" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-address-book"></i>
              </div>
              <div class="">
                <p>
                  Guest
                </p>
              </div>
          </router-link>
          <router-link to="/room" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-door-open"></i>
              </div>
              <div class="">
                <p>
                  Room
                </p>
              </div>
          </router-link>
          <router-link to="/checkin" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-calendar-plus"></i>
              </div>
              <div class="">
                <p>
                  Check In
                </p>
              </div>
          </router-link>
          <router-link to="/in-house" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-house-user"></i>
              </div>
              <div class="">
                <p>
                  In House
                </p>
              </div>
          </router-link>
          <router-link to="/checkout" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-calendar-minus"></i>
              </div>
              <div class="">
                <p>
                  Check Out
                </p>
              </div>
          </router-link>
          
          <div class="">
            <a href="" class="nav-link d-flex justify-content-between align-items-center w-full mb-0" data-bs-toggle="collapse" :data-bs-target="'#housekeeping-sub'" aria-expanded="false" aria-controls="housekeeping-sub">
              <div style="">
                <i class="nav-icon fas fa-broom mr-2"></i>
                <p>
                  Housekeeping
                </p>
              </div>
              <i class="nav-icon fas fa-angle-down"></i>
            </a>
            <div id="housekeeping-sub" class="collapse ms-5 me-4" :class="{ show: isActive }">          
                <router-link to="/schedule" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/schedule', 'text-muted py-2': $route.path !== '/schedule'}">
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p :class="{'mb-0': $route.path === '/schedule', '': $route.path !== '/schedule'}">Schedule</p>
                </router-link>
                <router-link to="/cleaning" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/cleaning', 'text-muted': $route.path !== '/cleaning'}">
                  <!-- <i class="fas fa-calendar-day nav-icon"></i> -->
                  <p :class="{'mb-0': $route.path === '/cleaning', '': $route.path !== '/schedule'}">Cleaning</p>
                </router-link>
            </div>
          </div>
          <router-link to="/maintenance" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-wrench"></i>
              </div>
              <div class="">
                <p>
                  Maintenance
                </p>
              </div>
          </router-link>
          <router-link to="/extracharge" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-hand-holding-usd"></i>
              </div>
              <div class="">
                <p>
                  Extra Charge
                </p>
              </div>
          </router-link>
          <!-- <router-link to="/inventory" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-boxes"></i>
              </div>
              <div class="">
                <p>
                 Inventory
                </p>
              </div>
          </router-link> -->
          <div class="">
            <a  class="nav-link d-flex justify-content-between align-items-center w-full mb-0" data-bs-toggle="collapse" :data-bs-target="'#inventory-sub'" aria-expanded="false" aria-controls="inventory-sub">
              <div style="">
                <i class="nav-icon fas fa-boxes mr-2"></i>
                  <p>
                    Inventory
                  </p>
              </div>
              <i class="nav-icon fas fa-angle-down"></i>
              
            </a>
            <div id="inventory-sub" class="collapse ms-5 me-4" :class="{ show: isActive }">
                <router-link to="/inventory" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/inventory', 'text-muted py-2': $route.path !== '/inventory'}">
                  <p :class="{'mb-0': $route.path === '/inventory', '': $route.path !== '/inventory'}">Overall</p>
                </router-link>
                <router-link to="/inventorywarehouse" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/inventorywarehouse', 'text-muted py-2': $route.path !== '/inventorywarehouse'}">
                  <p :class="{'mb-0': $route.path === '/inventorywarehouse', '': $route.path !== '/inventorywarehouse'}">Ware House</p>
                </router-link>
                <router-link to="/inventoryroom" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/inventoryroom', 'text-muted py-2': $route.path !== '/inventoryroom'}">
                  <p :class="{'mb-0': $route.path === '/inventoryroom', '': $route.path !== '/inventoryroom'}">Room</p>
                </router-link>
                <router-link to="/inventorydefact" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/inventoryspoil', 'text-muted py-2': $route.path !== '/inventoryspoil'}">
                  <p :class="{'mb-0': $route.path === '/inventorydefact', '': $route.path !== '/inventoryspoil'}">Defact</p>
                </router-link>
            </div>
          </div>
          <div class="">
            <a  class="nav-link d-flex justify-content-between align-items-center w-full mb-0" data-bs-toggle="collapse" :data-bs-target="'#report-sub'" aria-expanded="false" aria-controls="report-sub">
              <div style="">
                <i class="nav-icon fas fa-copy mr-2"></i>
                  <p>
                    Laporan
                  </p>
              </div>
              <i class="nav-icon fas fa-angle-down"></i>
              
            </a>
            <div id="report-sub" class="collapse pl-5 me-4" :class="{ show: isActive }">
                <router-link to="/reservation-report" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/reservation-report', 'text-muted py-2': $route.path !== '/reservation-report'}">
                  <p :class="{'mb-0': $route.path === '/reservation-report', '': $route.path !== '/reservation-report'}">Reservation Report</p>
                </router-link>
                <router-link to="/imigration-report" :class="{'d-flex align-items-center bg-primary rounded-lg p-2 my-2': $route.path === '/imigration-report', 'text-muted py-2': $route.path !== '/imigration-report'}">
                  <p :class="{'mb-0': $route.path === '/imigration-report', '': $route.path !== '/imigration-report'}">Imigration Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Guests Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Transaction Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Extracharge Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Maintenance Report</p>
                </router-link>
                <router-link to="/" class="text-muted">
                  <p>Inventory Report</p>
                </router-link>
            </div>
          </div>
          <router-link to="/admin" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-user-cog"></i>
              </div>
              <div class="">
                <p>
                  Admin
                </p>
              </div>
          </router-link>
          <router-link to="/staff" class="nav-link d-flex" active-class="bg-primary" exact-active-class="bg-primary">
              <div class="" style="width: 15%">
                <i class="nav-icon fas fa-users"></i>
              </div>
              <div class="">
                <p>
                  Staff
                </p>
              </div>
          </router-link>
         
          <!-- <li class="nav-header">Master Data</li> -->
          
          
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
  </section>
</template>

<script>
import { computed } from 'vue'
export default {

  setup(){
    const isActive = computed(() => {
      return window.location.pathname === '/schedule' || window.location.pathname === '/cleaning';
    })

    return {
      isActive
    }
  }
  
}
</script>

<style>

</style>